import { render } from "./section-set.vue?vue&type=template&id=5bac5503&scoped=true&ts=true"
import script from "./section-set.vue?vue&type=script&lang=ts"
export * from "./section-set.vue?vue&type=script&lang=ts"

import "./section-set.vue?vue&type=style&index=0&id=5bac5503&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bac5503"]])

export default __exports__